import React, { useEffect, useRef, useState } from 'react';
import { useTooltipState } from '../contexts/TooltipContext';

const Tooltip: React.FC = () => {
    const { tooltipText, position } = useTooltipState();
    const tooltipRef = useRef<HTMLDivElement>(null);
    const [coords, setCoords] = useState({ x: 0, y: 0 });

    useEffect(() => {
        if (tooltipText && tooltipRef.current) {
            const tooltipWidth = tooltipRef.current.offsetWidth;
            const tooltipHeight = tooltipRef.current.offsetHeight;
            const windowWidth = window.innerWidth;

            let x = position.x;
            let y = position.y - tooltipHeight - 10; // Default: above the cursor

            // Adjust if going off screen
            if (x + tooltipWidth > windowWidth) {
                x = windowWidth - tooltipWidth - 10;
            }
            if (x < 0) {
                x = 10;
            }
            if (y < 0) {
                y = position.y + 20; // Show below if not enough space above
            }

            setCoords({ x, y });
        }
    }, [tooltipText, position]);

    if (!tooltipText) return null;

    return (
        <div
            ref={tooltipRef}
            className="fixed z-[9999] px-3 py-1 bg-gray-800 text-white text-xs rounded shadow-lg pointer-events-none whitespace-normal break-words max-w-[calc(100vw-20px)] opacity-90 transition-opacity duration-200"
            style={{
                left: coords.x,
                top: coords.y,
            }}
        >
            {tooltipText}
            {/* Triangle arrow could be added here if desired, but simple bubble is fine */}
        </div>
    );
};

export default Tooltip;
